import React from 'react';
import PropTypes from 'prop-types';

import PlayerBookmark, { ICON_SIZE } from '.';

// Adapts a per-row saved-status descriptor onto the shared PlayerBookmark for list rows (global player
// search). Returns null when the feature flag is off so the row shows no bookmark at all; PlayerBookmark
// itself renders the greyed Free state and the outline/filled/loading Power states.
const RowPlayerBookmark = (props) => {
    const { savedBookmark, className, size, 'data-testid': dataTestId } = props;

    if (!savedBookmark?.enabled) {
        return null;
    }

    const {
        playerId,
        playerName,
        isSaved,
        savedListIds,
        isLoading,
        onSaveSuccess,
        onRemoveSuccess,
    } = savedBookmark;

    return (
        <PlayerBookmark
            playerId={playerId}
            playerName={playerName}
            isSaved={isSaved}
            isLoading={isLoading}
            savedListIds={savedListIds}
            onSaveSuccess={onSaveSuccess ? () => onSaveSuccess(playerId) : null}
            onRemoveSuccess={onRemoveSuccess ? () => onRemoveSuccess(playerId) : null}
            className={className}
            size={size}
            data-testid={dataTestId}
        />
    );
};

RowPlayerBookmark.propTypes = {
    savedBookmark: PropTypes.shape({
        enabled: PropTypes.bool,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        playerName: PropTypes.string,
        isSaved: PropTypes.bool,
        savedListIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        isLoading: PropTypes.bool,
        onSaveSuccess: PropTypes.func,
        onRemoveSuccess: PropTypes.func,
    }),
    className: PropTypes.string,
    size: PropTypes.number,
    'data-testid': PropTypes.string,
};

RowPlayerBookmark.defaultProps = {
    savedBookmark: null,
    className: null,
    // Defaults to the shared bookmark size so rows match the profile bookmark unless a caller shrinks it.
    size: ICON_SIZE,
    'data-testid': null,
};

export default RowPlayerBookmark;
